import {Link} from 'react-router-dom';
import {useParams} from 'react-router-dom';
import {useState,useEffect} from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './MyStyles.css';

import {baseUrl, userLocation, ipAddress, userName} from './Univ.js'
function Menu(){
    const userGroup= localStorage.getItem('userGroup');
    return (
        <section >
              <div className="row ">

              {userGroup === 'Admin' || userGroup === 'FrontOffice' ? (
                <div className="col-sm-2 me-4">
                <div className="card shadow mt-4" id="my-card">
                <div className="card-body">
                <a href="/front-menu/" data-toggle="tooltip" title="Front Office">
                <FontAwesomeIcon icon="fa fa-h-square" size="4x" className="mx-auto d-block"color="#2194d9" />
                <p className="fw-bold pt-2 text-center">Front Office</p></a>
                </div>
                </div>
                </div>
              ) : null}
              {userGroup === 'Admin' || userGroup === 'Lab' ? (
                <div className="col-sm-2 me-4">
                <div className="card shadow mt-4" id="my-card">
                <div className="card-body">
                <a  href="/lab-menu/" data-toggle="tooltip" title="Lab"><FontAwesomeIcon icon="fa fa-flask-vial " size="4x" className="mx-auto d-block" color="#2194d9" /><p className="fw-bold pt-2 text-center">LAB</p></a>
                </div>
                </div>
                </div>
              ) : null}
              {userGroup === 'Admin' || userGroup === 'Radiology' ? (
                <div className="col-sm-2 me-4">
                <div className="card shadow mt-4" id="my-card">
                <div className="card-body">
                <a href="/inv-menu/" data-toggle="tooltip" title="Radiology"><FontAwesomeIcon icon="fa-brands fa-square-odnoklassniki" size="4x" className="mx-auto d-block"color="#2194d9"/><p className="fw-bold pt-2 text-center">Radiology</p></a>
                </div>
                </div>
                </div>
              ) : null}
              {userGroup === 'Admin' || userGroup === 'Consultant' ? (
                <div className="col-sm-2 me-4">
                <div className="card shadow mt-4" id="my-card">
                <div className="card-body">
                <a href="/pat-search/" data-toggle="tooltip" title="EMR"><FontAwesomeIcon icon="fa-solid fa-file-waveform " size="4x" className="mx-auto d-block"color="#2194d9" /><p className="fw-bold pt-2 text-center">EMR</p></a>
                </div>
                </div>
                </div>
              ) : null}

              {userGroup === 'Patient' ? (
                <div className="col-sm-2 me-4">
                <div className="card shadow mt-4" id="my-card">
                <div className="card-body">
                <a href="/pat-menu/" data-toggle="tooltip" title="Patient"><FontAwesomeIcon icon="fa fa-gears " size="4x" className="mx-auto d-block"color="#2194d9" /><p className="fw-bold pt-2 text-center">Patient</p></a>
                </div>
                </div>
                </div>
              ) : null}                               
              {userGroup === 'Admin' || userGroup === 'Consultant' || userGroup === 'FrontOffice' || userGroup === 'Nurse' || userGroup === 'Lab' || userGroup === 'Radiology' || userGroup === 'Pharmacy' || userGroup === 'Pharmacy Store' || userGroup === 'Ip' || userGroup === 'Ot' || userGroup === 'Stores' || userGroup === 'Management' || userGroup === 'Ip' || userGroup === 'Ot' || userGroup === 'Accounting' || userGroup === 'Blood Bank' ? (
                <>
                <div className="col-sm-2 me-4">
                <div className="card shadow mt-4" id="my-card">
                <div className="card-body">
                <a href="/support/" data-toggle="tooltip" title="Support"><FontAwesomeIcon icon="fa fa-wrench " size="4x" className="mx-auto d-block"color="#2194d9" /><p className="fw-bold pt-2 text-center">MGM Support</p></a>
                </div>
                </div>
                </div>
                </>
                ) : null}

             </div>
        </section>
    )
}

export default Menu;